import { AsyncPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, OnInit, ViewEncapsulation, ViewRef } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { RouterLink } from '@angular/router';
import { OAuthLibWrapperService, TranslatePipe, WindowRef } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { BaseSiteConfigService } from 'src/app/service/base-site/base-site-config.service';
import { StorageService } from 'src/app/service/storage/storage.service';
import { ForgotPasswordService, ForgotPayload } from 'src/app/service/user/forgot-password.service';
import { LoginService } from 'src/app/service/user/login.service';
import { ASM_ENABLED_LOCAL_STORAGE_KEY } from '../../asm/asm-constant';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    NgClass,
    RouterLink,
    NgTemplateOutlet,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    AsyncPipe,
    TranslatePipe,
  ],
})
export class ForgotPasswordComponent implements OnInit {
  data$: Observable<any[]> = this.componentData.data$;
  forgotPasswordForm: FormGroup;
  // emailFormControl: FormControl;
  forgotten: any;
  forgotten$: Observable<any>;
  submitted: boolean;
  payload: ForgotPayload = { userId: '' };
  isSuccess: boolean;
  err: boolean = false;
  errorMsg: string;
  isDisabled = true;
  header = document.querySelector('header');
  globalMsg = document.querySelector('cx-global-message');
  asmEnabled = this.storageService.getLocalStorageItem(ASM_ENABLED_LOCAL_STORAGE_KEY);
  rightContentSlot = document.querySelector('.RightContentSlot');
  shimanoNewEmailRegex: string;

  constructor(
    protected componentData: CmsComponentData<any>,
    private forgotService: ForgotPasswordService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef,
    private storageService: StorageService,
    private winRef: WindowRef,
    private baseSiteConfigService: BaseSiteConfigService,
    private oAuthLibWrapperService: OAuthLibWrapperService,
    private loginService: LoginService
  ) {}

  ngOnInit() {
    this.getEmailRegex$().subscribe((data) => (this.shimanoNewEmailRegex = data));
    this.data$.pipe(take(1)).subscribe((data) => data);
    this.submitted = false;
    this.isSuccess = false;
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.pattern(this.shimanoNewEmailRegex), Validators.required, Validators.email]],
    });

    this.header.style.display = 'none';
  }

  ngAfterViewChecked() {
    this.rightContentSlot.classList.remove('right-content-full-height');
    if (this.rightContentSlot.scrollHeight < window.innerHeight) {
      this.rightContentSlot.classList.add('right-content-full-height');
    }
  }

  emailChange(event: any, invalid: any) {
    if (event.target.value !== '' && !invalid) {
      this.isDisabled = false;
    } else {
      this.isDisabled = true;
    }
    this.cdr.detectChanges();
  }

  forgotPassword() {
    this.globalMsg.setAttribute('style', 'display:none;');
    this.submitted = true;
    this.err = this.errorMsg == '' ? false : true;

    const email = this.forgotPasswordForm.controls.email.value;

    if (this.forgotPasswordForm.invalid) {
      this.isSuccess = false;
      return;
    } else {
      this.payload.userId = email;
    }
    this.forgotService
      .postForgottenPassword(this.payload)
      .pipe(take(1))
      .subscribe(
        (data) => {
          this.isSuccess = true;
          this.cdr.detectChanges();
          document.querySelector('.forgot-reset-password-bottom-pr').classList.add('d-none');
          return data;
        },
        (err) => {
          this.errorHandlr(err);
          this.isSuccess = false;
          this.cdr.detectChanges();
        }
      );
    if (!(this.cdr as ViewRef).destroyed) {
      this.cdr.detectChanges();
    }
  }

  errorHandlr(error: any) {
    for (const er of error.error.errors) {
      this.errorMsg = er.message;
    }
    this.err = true;
  }

  clearErrorMessage() {
    this.errorMsg = '';
  }
  @HostListener('window:resize')
  onResize(): void {
    this.rightContentSlot.classList.remove('right-content-full-height');
    if (this.rightContentSlot.scrollHeight < window.innerHeight) {
      this.rightContentSlot.classList.add('right-content-full-height');
    }
  }

  getEmailRegex$(): Observable<string> {
    return this.baseSiteConfigService
      .getBaseSiteConfigValues$(['shimano.email.regex'])
      .pipe(
        map(
          (configs: any[]) =>
            configs &&
            configs.filter((config: any) => config.key === 'shimano.email.regex').map((res: any) => res.value)[0]
        )
      );
  }

  goToLogin(isAsm: boolean): void {
    const shouldInitLoginFlow = this.loginService.goToLogin({
      isAsm: isAsm,
      navigate: false,
    });

    if (shouldInitLoginFlow) {
      this.oAuthLibWrapperService.initLoginFlow();
    }
  }
}
